/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * GeoStrat API
 * Geopolitical strategy game simulation API - manage nations, diplomacy, trade, and military operations
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Account,
  AccountListResponse,
  ApiError,
  ClassNameListResponse,
  UserClasses
} from '../models';

import { customInstance } from '.././custom-instance';
import type { ErrorType } from '.././custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * List all accessible accounts.
 */
export const accountSwitchList = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AccountListResponse[]>(
      {url: `/all/account-switch/`, method: 'GET', signal
    },
      options);
    }




export const getAccountSwitchListQueryKey = () => {
    return [
    `/all/account-switch/`
    ] as const;
    }


export const getAccountSwitchListQueryOptions = <TData = Awaited<ReturnType<typeof accountSwitchList>>, TError = ErrorType<ApiError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountSwitchListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountSwitchList>>> = ({ signal }) => accountSwitchList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountSwitchList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountSwitchListQueryResult = NonNullable<Awaited<ReturnType<typeof accountSwitchList>>>
export type AccountSwitchListQueryError = ErrorType<ApiError>


export function useAccountSwitchList<TData = Awaited<ReturnType<typeof accountSwitchList>>, TError = ErrorType<ApiError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountSwitchList>>,
          TError,
          Awaited<ReturnType<typeof accountSwitchList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountSwitchList<TData = Awaited<ReturnType<typeof accountSwitchList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountSwitchList>>,
          TError,
          Awaited<ReturnType<typeof accountSwitchList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountSwitchList<TData = Awaited<ReturnType<typeof accountSwitchList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountSwitchList<TData = Awaited<ReturnType<typeof accountSwitchList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountSwitchListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * ViewSet for switching between accounts and classes.
 *
 * For regular users: Works with existing UserClass records
 * For superusers: Uses a single UserClass that gets reassigned
 */
export const accountSwitchRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Account>(
      {url: `/all/account-switch/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getAccountSwitchRetrieveQueryKey = (id: number,) => {
    return [
    `/all/account-switch/${id}/`
    ] as const;
    }


export const getAccountSwitchRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof accountSwitchRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountSwitchRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountSwitchRetrieve>>> = ({ signal }) => accountSwitchRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountSwitchRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountSwitchRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof accountSwitchRetrieve>>>
export type AccountSwitchRetrieveQueryError = ErrorType<ApiError>


export function useAccountSwitchRetrieve<TData = Awaited<ReturnType<typeof accountSwitchRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountSwitchRetrieve>>,
          TError,
          Awaited<ReturnType<typeof accountSwitchRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountSwitchRetrieve<TData = Awaited<ReturnType<typeof accountSwitchRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountSwitchRetrieve>>,
          TError,
          Awaited<ReturnType<typeof accountSwitchRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountSwitchRetrieve<TData = Awaited<ReturnType<typeof accountSwitchRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountSwitchRetrieve<TData = Awaited<ReturnType<typeof accountSwitchRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountSwitchRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Select an account and assign/update UserClass.
 *
 * Regular users: Use first available UserClass in this account
 * Superusers: Create or update their single UserClass for this account
 */
export const accountSwitchSelectAccountCreate = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserClasses>(
      {url: `/all/account-switch/${id}/select_account/`, method: 'POST', signal
    },
      options);
    }




export const getAccountSwitchSelectAccountCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountSwitchSelectAccountCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof accountSwitchSelectAccountCreate>>, TError,{id: number}, TContext> => {

const mutationKey = ['accountSwitchSelectAccountCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountSwitchSelectAccountCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  accountSwitchSelectAccountCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccountSwitchSelectAccountCreateMutationResult = NonNullable<Awaited<ReturnType<typeof accountSwitchSelectAccountCreate>>>

    export type AccountSwitchSelectAccountCreateMutationError = ErrorType<ApiError>

    export const useAccountSwitchSelectAccountCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountSwitchSelectAccountCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountSwitchSelectAccountCreate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAccountSwitchSelectAccountCreateMutationOptions(options), queryClient);
    }
    /**
 * Select a specific class within the current account.
 *
 * Regular users: Switch to their UserClass for this class
 * Superusers: Update their UserClass to point to this class
 */
export const accountSwitchSelectClassCreate = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserClasses>(
      {url: `/all/account-switch/${id}/select_class/`, method: 'POST', signal
    },
      options);
    }




export const getAccountSwitchSelectClassCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountSwitchSelectClassCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof accountSwitchSelectClassCreate>>, TError,{id: number}, TContext> => {

const mutationKey = ['accountSwitchSelectClassCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountSwitchSelectClassCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  accountSwitchSelectClassCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccountSwitchSelectClassCreateMutationResult = NonNullable<Awaited<ReturnType<typeof accountSwitchSelectClassCreate>>>

    export type AccountSwitchSelectClassCreateMutationError = ErrorType<ApiError>

    export const useAccountSwitchSelectClassCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountSwitchSelectClassCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountSwitchSelectClassCreate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAccountSwitchSelectClassCreateMutationOptions(options), queryClient);
    }
    /**
 * List all classes in the current account that the user can access.
 *
 * Regular users: Classes where they have a UserClass
 * Superusers: All classes in the current account
 */
export const accountSwitchListClassesList = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ClassNameListResponse[]>(
      {url: `/all/account-switch/list_classes/`, method: 'GET', signal
    },
      options);
    }




export const getAccountSwitchListClassesListQueryKey = () => {
    return [
    `/all/account-switch/list_classes/`
    ] as const;
    }


export const getAccountSwitchListClassesListQueryOptions = <TData = Awaited<ReturnType<typeof accountSwitchListClassesList>>, TError = ErrorType<ApiError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchListClassesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountSwitchListClassesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountSwitchListClassesList>>> = ({ signal }) => accountSwitchListClassesList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountSwitchListClassesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountSwitchListClassesListQueryResult = NonNullable<Awaited<ReturnType<typeof accountSwitchListClassesList>>>
export type AccountSwitchListClassesListQueryError = ErrorType<ApiError>


export function useAccountSwitchListClassesList<TData = Awaited<ReturnType<typeof accountSwitchListClassesList>>, TError = ErrorType<ApiError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchListClassesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountSwitchListClassesList>>,
          TError,
          Awaited<ReturnType<typeof accountSwitchListClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountSwitchListClassesList<TData = Awaited<ReturnType<typeof accountSwitchListClassesList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchListClassesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountSwitchListClassesList>>,
          TError,
          Awaited<ReturnType<typeof accountSwitchListClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountSwitchListClassesList<TData = Awaited<ReturnType<typeof accountSwitchListClassesList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchListClassesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountSwitchListClassesList<TData = Awaited<ReturnType<typeof accountSwitchListClassesList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountSwitchListClassesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountSwitchListClassesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






